/**
 * 构建模式类型
 */
enum ModeType {
  /** 开发环境 */
  DEV = 'development',
  /** 生产环境 */
  PROD = 'production',
  /** 英文 */
  EN = 'en',
  /** 日文 */
  JP = 'jp',
  /** 韩文 */
  KR = 'kr',
  /** 亚马逊 */
  AMZON = 'amazon',
}

export default ModeType
